/* eslint-disable prefer-destructuring */

import { BuiltInTooltip } from '../../tooltip/types';

const voipMetric = (key, label, color) => ({
    key,
    label,
    color,
    units: '',
    multiplier: 2,
});

export const voipChartDef = {
    tooltip: BuiltInTooltip,
    chartType: 'spline',
    statusMetric: 'status',
    yAxis: [
        {
            title: {
                text: 'MOS',
            },
        },
    ],
    chartTrends: [
        voipMetric('avgLqmosRx', 'Caller MOS', '#00A3C7'),
        {
            hidden: true,
            tooltip: true,
            key: 'avgPctLossRx',
            label: 'Caller Loss',
            units: '%',
            multiplier: 1,
        },
        {
            hidden: true,
            tooltip: true,
            key: 'avgRttRx',
            label: 'Caller Latency',
            units: 'ms',
            multiplier: 1,
        },
        {
            hidden: true,
            tooltip: true,
            key: 'avgJitterRx',
            label: 'Caller Jitter',
            units: 'ms',
            multiplier: 1,
        },
        voipMetric('avgLqmosTx', 'Callee MOS', '#C5007C'),
        {
            hidden: true,
            tooltip: true,
            key: 'avgPctLossTx',
            label: 'Callee Loss',
            units: '%',
            multiplier: 1,
        },
        {
            hidden: true,
            tooltip: true,
            key: 'avgRttTx',
            label: 'Callee Latency',
            units: 'ms',
            multiplier: 1,
        },
        {
            hidden: true,
            tooltip: true,
            key: 'avgJitterTx',
            label: 'Callee Jitter',
            units: 'ms',
            multiplier: 1,
        },
    ],
};
